import { NgModule, Type } from '@angular/core';
import { HasPermissionDirective } from './permissions/has-permission.directive';
import { TranslateKeyDirective } from './translate/translate-key.directive';
import { TranslateTextDirective } from './translate/translate-text.directive';

const directives: Type<any>[] = [
  HasPermissionDirective,
  TranslateKeyDirective,
  TranslateTextDirective,
];

@NgModule({
  imports: [...directives],
  exports: [...directives],
})
export class DirectivesModule {}
